module.exports = __webpack_public_path__ + "2b3aff8e1962abf7fc6d2151e15ee3e3.jpg";